<template>
  <div id="report-detail">
    <v-row justify="center">
      <v-col class="text-center">
        <h3>รายงานภาษีขาย</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-center">
        <span class="text-title-month">ประจำเดือน</span>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="dateSelect"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="button-select"
              width="200px"
              height="40px"
              v-model="dateSelect"
              v-bind="attrs"
              style="border: solid 1px #c4c4c4; border-radius: 10px; justify-content: space-between; box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0); font-size: 16px;"
              v-on="on"
            >
              <div>
                <span>{{ getMontFromCalender(dateSelect) }}</span>
              </div>
              <img src="/images/icon-angle-down.svg" style="max-width: 14px; max-height: 14px;" alt="dropdown" />
            </v-btn>
          </template>
          <v-date-picker v-model="dateSelect" type="month" no-title scrollable locale="th">
            <v-spacer></v-spacer>
            <v-btn text color="#c84f99" @click="menu = false">Cancel</v-btn>
            <v-btn text color="#c84f99" @click="setSelectDate(dateSelect)">OK</v-btn>
          </v-date-picker>
        </v-menu>
        <span class="text-title-month tw-ml-6">ประเภทภาษี</span>
        <v-select
          v-model="selectedVatTypes"
          :items="vatTypeOptions"
          multiple
          dense
          outlined
          hide-details
          class="vat-type-select"
        >
          <!-- ช่องมีที่จำกัด แสดงเป็นสรุปบรรทัดเดียวแทนการต่อชื่อทุกประเภท -->
          <template v-slot:selection="{ index }">
            <span v-if="index === 0" class="vat-type-selection">{{ vatTypeSummary }}</span>
          </template>
        </v-select>
        <v-btn
          text
          class="tw-px-4 tw-py-2 tw-ml-4 tw-rounded-md tw-relative tw-text-light-green hover:tw-bg-light-green hover:tw-text-white"
          @click="exportReport"
        >
          <v-icon left>mdi-file-document-multiple</v-icon>
          ส่งออกข้อมูล CSV
        </v-btn>
        <v-btn
          text
          class="tw-px-4 tw-py-2 tw-ml-2 tw-rounded-md tw-relative tw-text-light-green hover:tw-bg-light-green hover:tw-text-white"
          @click="exportReportExcel"
        >
          <v-icon left>mdi-file-excel</v-icon>
          ส่งออกข้อมูล Excel
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="2" class="col-response">
        <b>ชื่อผู้ประกอบการ</b>
      </v-col>
      <v-col md="5" class="col-response">{{ companyDetail.nameTH }}</v-col>
      <v-col md="2" class="col-response">
        <b>เลขที่ประจำตัวผู้เสียภาษี</b>
      </v-col>
      <v-col>{{ companyDetail.taxID }}</v-col>
    </v-row>
    <v-row>
      <v-col md="2" class="col-response">
        <b>ชื่อสถานประกอบการ</b>
      </v-col>
      <v-col md="5" class="col-response">{{ companyDetail.nameTH }}</v-col>
      <v-col>
        <v-radio-group :value="selectedBranch" disabled row>
          <v-radio label="สำนักงานใหญ่" value="00000"></v-radio>
          <v-radio label="สาขา" :value="selectedBranch !== '00000' && selectedBranch"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="2" class="col-response-non" />
      <v-col md="10" class="col-response">{{ this.getAddress(companyDetail.address) }}</v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col style="overflow-x:auto;">
        <table style="width:100%; margin-bottom: 10px;">
          <thead>
            <tr class="row-header">
              <th rowspan="2" class="text-center">ลำดับที่</th>
              <th colspan="2" class="text-center">ใบกำกับภาษี</th>
              <th rowspan="2" class="text-center">Ref.</th>
              <th rowspan="2" class="text-center">ชื่อผู้ซื้อ / ชื่อบริษัท</th>
              <th rowspan="2" class="text-center">เลขผู้เสียภาษี</th>
              <th colspan="2" class="text-center">สถานประกอบการ</th>
              <th rowspan="2" class="text-center">มูลค่าที่นำมาคิดภาษีมูลค่าเพิ่ม</th>
              <th rowspan="2" class="text-center">ภาษีมูลค่าเพิ่ม</th>
              <th rowspan="2" class="text-center">ยอดรวมทั้งหมด</th>
              <th rowspan="2" class="text-center">หมายเหตุ</th>
            </tr>
            <tr class="row-header">
              <th class="text-center">วันที่</th>
              <th class="text-center">เลขที่</th>
              <th class="text-center">สำนักงานใหญ่</th>
              <th class="text-center">สาขาที่</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loadingData">
              <td colspan="11">
                <v-progress-linear indeterminate color="#6ec39b"></v-progress-linear>
              </td>
            </tr>
            <tr v-for="row in visibleRows" :key="row.key">
              <td class="text-center">{{ row.orderText }}</td>
              <td class="text-center">{{ row.dateText }}</td>
              <td class="text-center">{{ row.docNo }}</td>
              <td class="text-center">{{ row.refText }}</td>
              <td>{{ row.buyerName }}</td>
              <td class="text-center">{{ row.taxIdText }}</td>
              <td class="text-center">{{ row.headOfficeText }}</td>
              <td class="text-center">{{ row.branchText }}</td>
              <td class="text-right">{{ row.basisText }}</td>
              <td class="text-right">{{ row.taxText }}</td>
              <td class="text-right">{{ row.totalText }}</td>
              <td class="text-right">{{ row.noteText }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr v-for="line in footerLines" :key="line.label">
              <td colspan="8" class="text-right">{{ line.label }}</td>
              <td class="text-right">{{ getFormatAmount(line.amount) }} </td>
              <td class="text-right">{{ getFormatAmount(line.tax) }}</td>
              <td class="text-right">{{ getFormatAmount(line.total) }}</td>
              <td></td>
            </tr>
            <!-- ชื่อยอดรวมอยู่บรรทัดเดียวกับตัวเลขที่มันเรียก ไม่ใช่ลอยเป็นหัวอยู่เหนือกลุ่มย่อย -->
            <tr class="row-header-total">
              <td colspan="8" class="text-right title-total">ยอดขายรวมตาม Tax report</td>
              <td class="text-right total-text">{{ getFormatAmount(footerTotal.amount) }}</td>
              <td class="text-right total-text">{{ getFormatAmount(footerTotal.tax) }}</td>
              <td class="text-right total-text">{{ getFormatAmount(footerTotal.total) }}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from "moment"
import "moment/locale/th"
import { mapState } from "vuex"
import "moment/locale/th"
import formatTwoDecimal from "@/libs/formatTwoDecimal"
import libCSV from "@/libs/libCSV"
import { getVatSplit } from "@/libs/vatSplit"
import { isCancelledDoc, reportAmount } from "@/libs/reportAmount"
import {
  rowVatCategory,
  VAT_TYPES,
  VAT_TYPE_OPTIONS,
  VAT_TYPE_LABELS,
  VAT_7,
  VAT_0,
  VAT_FRE,
} from "@/libs/vatCategory"
import * as XLSX from "xlsx";

moment.locale("th")

// ใช้ formatter ตัวเดียวกับทุกแถว แทนการ new ทุกครั้งใน template
const orderFormat = new Intl.NumberFormat()

export default {
  name: "ReportDetail",
  computed: {
    ...mapState({
      companyDetail: (state) => state.companies.companyDetail,
      docList: (state) => state.docs.docList,
      loadingData: (state) => state.docs.loading,
      selectedBranch: (state) => state.companies.selectedBranch,
    }),
    // 1 เอกสารอาจกลายเป็น 2 บรรทัด เมื่อมีทั้งรายการ VAT 0 และรายการที่คิดภาษี
    //
    // ข้อความทุกช่องถูกคำนวณไว้ที่นี่ครั้งเดียว ไม่คำนวณใน template
    // เพราะรายงานเดือนที่เอกสารเยอะมีได้เป็นหมื่นบรรทัด
    reportRows() {
      const rows = []
      const dateTextCache = new Map()
      let order = 0

      for (const doc of this.docList || []) {
        if (doc["@DocType"] === 5) {
          continue
        }
        order += 1

        const split = getVatSplit(doc)
        const parts = split
          ? [
              { raw: split.nonVat, isVatZeroRow: true, category: VAT_0 },
              split.fre ? { raw: split.fre, isVatZeroRow: true, category: VAT_FRE } : null,
              split.vat ? { raw: split.vat, isVatZeroRow: false, category: VAT_7 } : null,
            ].filter(Boolean)
          : [
              {
                raw: {
                  basis: doc["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"],
                  tax: doc["SCTT.AHTS.STSHMS.TaxTotalAmount"],
                  total: doc["SCTT.AHTS.STSHMS.GrandTotalAmount"],
                },
                isVatZeroRow: false,
              },
            ]

        const issueDate = doc["ED.IssueDateTime"]
        let dateText = dateTextCache.get(issueDate)
        if (dateText === undefined) {
          dateText = this.getDateWithFormat(issueDate)
          dateTextCache.set(issueDate, dateText)
        }

        const cancelled = isCancelledDoc(doc)
        const branchID = doc["@BuyerBranchID"]
        // ช่องที่เหมือนกันทุกบรรทัดของเอกสารใบเดียวกัน คำนวณครั้งเดียวต่อเอกสาร
        const shared = {
          orderText: orderFormat.format(order),
          dateText: dateText,
          docNo: doc["ED.ID"],
          refText: this.getRefDoc(doc["SCTT.AHTA.ARD"]),
          buyerName: doc["SCTT.AHTA.BTP.Name"],
          taxIdText: (doc["SCTT.AHTA.BTP.STR.ID"] || "").slice(0, 13) || "-",
          headOfficeText: branchID && branchID === "00000" ? branchID : "-",
          branchText: branchID && branchID !== "00000" ? branchID : "-",
          noteText: cancelled ? "ยกเลิก" : "",
        }

        parts.forEach((part, partIndex) => {
          // ยอดที่ "แสดงจริง" ของแถวนี้ — ยอดรวมท้ายรายงานบวกจากค่าชุดนี้
          // ไม่ใช่คำนวณแยกอีกทาง ตัวเลขสองที่จะได้ไม่มีวันไม่ตรงกัน
          const basisValue = reportAmount(doc, part.raw.basis)
          const taxValue = reportAmount(doc, part.raw.tax)
          const totalValue = reportAmount(doc, part.raw.total)
          rows.push({
            ...shared,
            vatCategory: rowVatCategory(doc, part),
            key: doc.id + "-" + partIndex,
            order: order,
            doc: doc,
            raw: part.raw,
            isVatZeroRow: part.isVatZeroRow,
            basisValue: basisValue,
            taxValue: taxValue,
            totalValue: totalValue,
            basisText: formatTwoDecimal(basisValue),
            taxText: part.isVatZeroRow ? "-" : formatTwoDecimal(taxValue),
            totalText: formatTwoDecimal(totalValue),
          })
        })
      }
      return rows
    },
    // ไม่เลือกอะไรเลยถือว่าไม่กรอง — ไม่งั้นรายงานจะว่างทั้งหน้าโดยไม่มีอะไรอธิบาย
    activeVatTypes() {
      return this.selectedVatTypes.length ? this.selectedVatTypes : VAT_TYPES
    },
    visibleRows() {
      const picked = this.activeVatTypes
      if (picked.length === VAT_TYPES.length) {
        return this.reportRows
      }
      return this.reportRows.filter((row) => picked.indexOf(row.vatCategory) !== -1)
    },
    footerLines() {
      const picked = this.activeVatTypes
      const rows = this.visibleRows
      return VAT_TYPES.filter((type) => picked.indexOf(type) !== -1)
        .map((type) =>
          Object.assign(
            { type: type, label: VAT_TYPE_LABELS[type] },
            this.sumOfRows(rows.filter((row) => row.vatCategory === type))
          )
        )
        // บรรทัดยกเว้นภาษีโผล่เฉพาะเมื่อมียอดจริง หรือเมื่อเลือกดูกลุ่มนี้กลุ่มเดียว
        // รายงานของบริษัทที่ยังไม่มีเอกสาร FRE จึงหน้าตาเหมือนเดิม
        .filter(
          (line) =>
            line.type !== VAT_FRE || picked.length === 1 || line.amount || line.total
        )
    },
    footerTotal() {
      return this.sumOfRows(this.visibleRows)
    },
    vatTypeSummary() {
      const picked = this.selectedVatTypes
      if (!picked.length || picked.length === VAT_TYPES.length) {
        return "ทั้งหมด"
      }
      if (picked.length === 1) {
        const option = VAT_TYPE_OPTIONS.find((item) => item.value === picked[0])
        return option ? option.text : "ทั้งหมด"
      }
      return "เลือก " + picked.length + " ประเภท"
    },
  },
  data() {
    return {
      menu: false,
      dateSelect: new Date().toISOString().substr(0, 7),
      vatTypeOptions: VAT_TYPE_OPTIONS,
      selectedVatTypes: [...VAT_TYPES],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // ยอดรวมทุกบรรทัดท้ายรายงานบวกจาก "แถวที่แสดงอยู่จริง" ไม่ใช่คำนวณแยกจาก
    // ยอดสรุปของ store ที่ตัดเอกสารยกเลิกทิ้งไปทั้งใบ ใบลดหนี้ที่ถูกยกเลิกจึงโชว์ยอด
    // กลับรายการอยู่ในตารางแต่ไม่เคยถูกนับในยอดรวม คอลัมน์เลยบวกแล้วไม่ตรงกับที่พิมพ์
    //
    // บวกจากแถวที่เห็น = กรองประเภทภาษีแล้วยอดรวมก็เดินตามเองด้วย ไม่ต้องคิดสองทาง
    sumOfRows(rows) {
      return rows.reduce(
        (acc, row) => ({
          amount: acc.amount + (Number(row.basisValue) || 0),
          tax: acc.tax + (Number(row.taxValue) || 0),
          total: acc.total + (Number(row.totalValue) || 0),
        }),
        { amount: 0, tax: 0, total: 0 }
      )
    },
    exportReport() {
      const rows = [
        [
          "ลำดับที่",
          "วันที่",
          "เลขที่",
          "Ref.",
          "ชื่อผู้ซื้อ/ชื่อบริษัท",
          "เลขผู้เสียภาษี",
          "สำนักงานใหญ่",
          "สาขาที่",
          "มูลค่าที่นำมาคิดภาษีมูลค่าเพิ่ม",
          "ภาษีมูลค่าเพิ่ม",
          "ยอดรวมทั้งหมด",

        ],
      ]

      for (const row of this.visibleRows) {
        const doc = row.doc

        rows.push([
          row.order,
          row.dateText,
          doc["ED.ID"],
          this.getRefDoc(doc["SCTT.AHTA.ARD"]),
          doc["SCTT.AHTA.BTP.Name"],
          row.taxIdText,
          doc["@BuyerBranchID"] && doc["@BuyerBranchID"] === "00000" ? doc["@BuyerBranchID"] : "-",
          doc["@BuyerBranchID"] && doc["@BuyerBranchID"] !== "00000" ? doc["@BuyerBranchID"] : "-",
          libCSV.stangToTHB(row.basisValue),
          libCSV.stangToTHB(row.taxValue),
          libCSV.stangToTHB(row.totalValue)
        ])
      }

      for (const line of this.footerLines) {
        rows.push([
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          line.label,
          libCSV.stangToTHB(line.amount),
          libCSV.stangToTHB(line.tax),
          libCSV.stangToTHB(line.total),
        ])
      }

      rows.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "ยอดขายรวมตาม Tax report",
        libCSV.stangToTHB(this.footerTotal.amount),
        libCSV.stangToTHB(this.footerTotal.tax),
        libCSV.stangToTHB(this.footerTotal.total),
      ])

      libCSV.exportCSV(`Reports_${this.dateSelect}.csv`, rows)
    },
    exportReportExcel() {
  const rows = [
    [
      "ลำดับที่",
      "วันที่",
      "เลขที่",
      "Ref.",
      "ชื่อผู้ซื้อ/ชื่อบริษัท",
      "เลขผู้เสียภาษี",
      "สำนักงานใหญ่",
      "สาขาที่",
      "มูลค่าที่นำมาคิดภาษีมูลค่าเพิ่ม",
      "ภาษีมูลค่าเพิ่ม",
      "ยอดรวมทั้งหมด",
      "หมายเหตุ"
    ],
  ];

  for (const row of this.visibleRows) {
    const doc = row.doc
    rows.push([
    { v: row.order.toString(), t: "s" },
      { v: this.getFormatDate(doc["ED.IssueDateTime"]), t: "s" }, // วันที่
      { v: doc["ED.ID"], t: "s" }, // เลขที่
      { v: this.getRefDoc(doc["SCTT.AHTA.ARD"]), t: "s" }, // Ref.
      { v: doc["SCTT.AHTA.BTP.Name"], t: "s" }, // ชื่อผู้ซื้อ/บริษัท
      { v: row.taxIdText, t: "s" }, // เลขผู้เสียภาษี
      { v: doc["@BuyerBranchID"] && doc["@BuyerBranchID"] === "00000" ? doc["@BuyerBranchID"] : "-", t: "s" }, // สำนักงานใหญ่
      { v: doc["@BuyerBranchID"] && doc["@BuyerBranchID"] !== "00000" ? doc["@BuyerBranchID"] : "-", t: "s" }, // สาขาที่
      { v: this.stangToTHB(row.basisValue), t: "n" }, // มูลค่าภาษีมูลค่าเพิ่ม
      { v: this.stangToTHB(row.taxValue), t: "n" }, // ภาษีมูลค่าเพิ่ม
      { v: this.stangToTHB(row.totalValue), t: "n" }, // ยอดรวมทั้งหมด
      { v: isCancelledDoc(doc) ? "ยกเลิก" : "", t: "s" }

    ]);

  }




  for (const line of this.footerLines) {
    rows.push([
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      line.label,
      { v: this.stangToTHB(line.amount), t: "n" },
      { v: this.stangToTHB(line.tax), t: "n" },
      { v: this.stangToTHB(line.total), t: "n" },
    ]);
  }

  rows.push([
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "ยอดขายรวมตาม Tax report",
    { v: this.stangToTHB(this.footerTotal.amount), t: "n" },
    { v: this.stangToTHB(this.footerTotal.tax), t: "n" },
    { v: this.stangToTHB(this.footerTotal.total), t: "n" },
  ]);

  console.log("Data rows populated:", rows); // Debugging statement


  const worksheet = XLSX.utils.aoa_to_sheet(rows);


  Object.keys(worksheet).forEach((cell) => {
    if (worksheet[cell].t === "n") {
      worksheet[cell].z = "#,##0.00"; // กำหนดรูปแบบตัวเลขใน Excel
    }
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, `Reports_${this.dateSelect}`);

  const fileName = `Reports_${this.dateSelect}.xlsx`;

  XLSX.writeFile(workbook, fileName);

  console.log("Excel file download triggered"); // Debugging statement
},


    // แปลงสตางค์เป็นบาทสำหรับไฟล์ Excel
    // ต้องคืนเป็น "ตัวเลข" เพราะ cell ถูกประกาศเป็น type "n"
    // ถ้าคืนเป็น string อย่างเดิม Excel จะขึ้นเตือน Number stored as text และ SUM ไม่ติด
    stangToTHB(v) {
      return Number(((Number(v) || 0) / 100).toFixed(2));
    },
    getFormatAmount(amount) {
      return formatTwoDecimal(amount)
    },
    getMontFromCalender: function (date) {
      return moment(date).add(543, "year").format("MMMM YYYY")
    },
    setSelectDate: function (dateSelect) {
      this.$refs.menu.save(dateSelect)
      this.dateSelect = dateSelect
      this.getData()
    },
    getData: function () {
      let companyID = this.$route.params.companyId
      let startDate = moment(this.dateSelect).startOf("day")
      let endDate = moment(this.dateSelect).endOf("month").endOf("day")
      this.$store.dispatch("companies/getCompany", { companyID })
      this.$store.dispatch("docs/getListByMonth", {
        companyID,
        startDate,
        endDate,
        reportBranchType: this.selectedBranch,
      })
    },
    getDateWithFormat: function (date) {
      return moment(new Date(date)).add(543, "year").format("Do MMM YY")
    },

    getFormatDate: function (date) {
    return moment(new Date(date)).format("DD/MM/YYYY");
    },

    getAddress: function (address) {
      let showAddress = ""
      if (!address) {
        return showAddress
      }
      if (address.addressNo) {
        showAddress += `เลขที่ ${address.addressNo}`
      }
      if (address.building) {
        showAddress += ` ${address.building}`
      }
      if (address.alley) {
        showAddress += ` ซอย ${address.alley}`
      }
      if (address.village) {
        showAddress += ` หมู่ที่ ${address.village}`
      }
      if (address.street) {
        showAddress += ` ถนน${address.street}`
      }
      if (address.subDistrict) {
        showAddress += ` แขวง${address.subDistrict}`
      }
      if (address.district) {
        showAddress += ` เขต${address.district}`
      }
      if (address.province) {
        showAddress += ` ${address.province}`
      }
      if (address.postCode) {
        showAddress += ` ${address.postCode}`
      }
      return showAddress
    },
    getRefDoc: function (refList) {
      if (!Array.isArray(refList) || refList.length === 0) return "-"
      let refShow = refList
        .map((x) => (x && x["IssuerAssignedID"]) || "")
        .filter(Boolean)
        .join(", ")
      return refShow.length > 0 ? refShow : "-"
    },
  },
  watch: {
    selectedBranch: {
      handler: function () {
        this.getData()
      },
    },
  },
}
</script>
<style lang="scss">
.vat-type-select {
  display: inline-block;
  vertical-align: middle;
  width: 200px;
  margin-left: 8px;

  .v-input__slot {
    min-height: 40px !important;
    border-radius: 10px;
  }

  fieldset {
    border-color: #c4c4c4;
  }

  .v-input__append-inner {
    margin-top: 8px !important;
  }
}

.vat-type-selection {
  font-size: 16px;
  white-space: nowrap;
}

#report-detail {
  .text-title-month {
    font-weight: bold;
    padding-right: 10px;
  }

  table,
  th,
  td {
    border: 1px solid white;
    border-collapse: collapse;
  }

  th,
  td {
    padding: 5px;
    text-align: left;
  }

  .total-text {
    color: #6ec39b;
  }

  .title-total {
    font-size: 18px;
    font-weight: bold;
  }

  .row-header {
    background-color: #ebebeb;
  }

  .row-header-total {
    line-height: 45px;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    border: 1px solid #ddd;
  }

  .v-btn:before {
    background-color: white;
  }

  .button-select {
    background-color: white !important;
  }

  .v-input--selection-controls {
    margin: unset;
  }

  .v-messages {
    display: none;
  }

  .v-input__slot {
    margin-bottom: unset;
  }

  .foot-style {
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  }

  .test2 {
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    position: fixed;
    bottom: 0;
    //background-color: white;
    padding: 50px;
    width: 100%;
    height: 170px;
    background-color: lightgoldenrodyellow;
  }

  @media only screen and (max-width: 599px) {
    .col-response {
      flex: 0 0 100%;
    }
    .col-response-non {
      display: none;
    }
  }
}
</style>
